<div class="charge-list mt-3" #chargeList>
    @for (charge of chargesFormArray.controls; track $index; let i = $index) {
    <div
      class="charge-row mt-2"
      [formGroup]="charge"
      fxLayout="row"
      fxLayoutGap="8px"
    >
      <div class="charge-fields" fxLayout="row wrap" fxLayoutGap="8px" fxFlex="1 1 auto">
        @if ((pbEnabled$ | async) && (hbEnabled$ | async)) {
        <mat-form-field
          subscriptSizing="dynamic"
          fxFlex="1 1 75px"
          hideRequiredMarker
        >
          <mat-label> {{ 'charges-table.form.pricing' | translate }}</mat-label>
          <mat-select
            formControlName="type"
            (selectionChange)="onItemTypeSelected($event.value, i)"
          >
            @if ((hbEnabled$ | async) ||
            chargesFormArray.at(i).get('type').value ===
            ChargeDescriptionMaster.TYPE.HB) {
            <mat-option [value]="ChargeDescriptionMaster.TYPE.HB">
              {{ ChargeDescriptionMaster.TYPE.HB.toUpperCase() }}
            </mat-option>
            } @if((pbEnabled$ | async) ||
            chargesFormArray.at(i).get('type').value ===
            ChargeDescriptionMaster.TYPE.PB) {
            <mat-option [value]="ChargeDescriptionMaster.TYPE.PB">
              {{ ChargeDescriptionMaster.TYPE.PB.toUpperCase() }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }

        <mat-form-field
          subscriptSizing="dynamic"
          fxFlex="1 0 380px"
          hideRequiredMarker
          class="charge-identity"
        >
          <mat-label>{{ 'charges-table.form.charge' | translate }}</mat-label>
          @if(!chargesFormArray.at(i).get('description').disabled) {
          <mat-select
            formControlName="description"
            [compareWith]="compareChargeOption"
            (selectionChange)="onItemSelected($event.value, i)"
          >
            <mat-select-trigger>{{ rowChargeSummary(i) }}</mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="
                  'charges-table.form.charge-search' | translate
                "
                [noEntriesFoundLabel]="
                  'charges-table.form.not-found' | translate
                "
                [searching]="loading$ | async"
                [formControl]="filterChargeCtrl"
              >
              </ngx-mat-select-search>
            </mat-option>
            @for (charge of filteredCdm$ | async; track charge.id) {
            <mat-option
              [disabled]="loading$ | async"
              [value]="charge"
              class="charge-option"
            >
              <span class="charge-option__content">
                <span class="charge-option__description">{{
                  charge.chargeDescription
                }}</span>
                <span class="charge-option__codes">
                  @if (charge.cptCode) {
                  <span class="charge-option__code">
                    {{ 'charges-table.form.cpt' | translate }}
                    {{ charge.cptCode }}
                  </span>
                  } @if (charge.chargeCode) {
                  <span class="charge-option__code">
                    {{ 'charges-table.form.charge-code' | translate }}
                    {{ charge.chargeCode }}
                  </span>
                  }
                </span>
              </span>
            </mat-option>
            }
          </mat-select>
          } @else {
          <input
            matInput
            formControlName="description"
            [matTooltip]="rowChargeSummary(i)"
          />
          }
          <!-- Static direct child: Angular cannot project into a named slot from inside @if. -->
          <span matTextSuffix class="charge-identity__codes">
            @if (chargesFormArray.at(i).get('description').disabled) { @for (code
            of rowChargeCodes(i); track code) {
            <span class="charge-identity__code">{{ code }}</span>
            } }
          </span>
        </mat-form-field>

        <!-- cptCode is surfaced as a chip above; this keeps the control DOM-bound for tests. -->
        <input type="hidden" formControlName="cptCode" />

        <mat-form-field
          subscriptSizing="dynamic"
          fxFlex="1 1 100px"
          hideRequiredMarker
        >
          <mat-label>
            {{ 'charges-table.form.modifiers' | translate }}</mat-label
          >
          <input matInput formControlName="modifiers" placeholder="26,50,TC" class="modifiers-input" />
        </mat-form-field>

        @if (hbEnabled$ | async) {
        <mat-form-field
          subscriptSizing="dynamic"
          fxFlex="1 1 100px"
          hideRequiredMarker
          *appHasPermission="'appointment.estimate.rev-code.view'"
        >
          <mat-label>
            {{ 'charges-table.form.rev-code' | translate }}</mat-label
          >
          <input matInput formControlName="revCode" />
        </mat-form-field>
        }

        <mat-form-field
          subscriptSizing="dynamic"
          fxFlex="1 1 75px"
          hideRequiredMarker
        >
          <mat-label>{{ 'charges-table.form.units' | translate }}</mat-label>
          <input matInput formControlName="quantity" type="number" min="1" />
        </mat-form-field>

        @if (showVisitNumbers) {
          <mat-form-field
            subscriptSizing="dynamic"
            fxFlex="1 1 135px"
            hideRequiredMarker
          >
            <mat-label>{{
              'charges-table.form.visit-number' | translate
            }}</mat-label>
            @if (noAppointmentsSelected) {
              <input
                matInput
                required
                placeholder="1-3,5"
                [disabled]="readOnly"
                [value]="formatVisitNumbers(i)"
                (input)="parseVisitNumbers($event.target.value, i)"
              />
            } @else {
              <mat-select
                formControlName="visitNumbers"
                [multiple]="true"
                [required]="true"
                (selectionChange)="visitNumbersValidator()"
              >
                @for (visitNumber of appointmentVisitNumbers; track visitNumber) {
                <mat-option [value]="visitNumber">
                  {{ visitNumber }}
                </mat-option>
                }
              </mat-select>
            }
          </mat-form-field>
        }

        @if (chargesFormArray.at(i).contains('cptDiscount') &&
        chargesFormArray.at(i).contains('discountType') ) {
        <mat-form-field
          subscriptSizing="dynamic"
          fxFlex="1 1 100px"
          hideRequiredMarker
        >
          <mat-label>
            {{ 'charges-table.form.discount' | translate }}
          </mat-label>
          <input
            matInput
            formControlName="cptDiscount"
            type="number"
            [min]="0"
            [max]="
              chargesFormArray.at(i).get('discountType').value ===
              EstimateChargeDiscountType.Percentage
                ? 100
                : undefined
            "
            [step]="1"
          />
          @if (chargesFormArray.at(i).get('discountType').value ===
          EstimateChargeDiscountType.Percentage) {
          <span matTextSuffix>%</span>
          } @else {
          <span matTextPrefix>$</span>
          }
        </mat-form-field>

        <mat-form-field
          subscriptSizing="dynamic"
          fxFlex="1 1 125px"
          hideRequiredMarker
        >
          <mat-label>
            {{ 'charges-table.form.discounted-units' | translate }}
          </mat-label>
          <input
            matInput
            formControlName="discountedUnits"
            type="number"
            [min]="1"
            [max]="chargesFormArray.at(i).get('quantity').value"
            [step]="1"
            [placeholder]="chargesFormArray.at(i).get('quantity').value?.toString() || ''"
          />
        </mat-form-field>
        }

        <mat-form-field
          subscriptSizing="dynamic"
          class="no-display"
          fxFlex="1 1 100px"
          hideRequiredMarker
        >
          <mat-label>{{ 'charges-table.form.facility' | translate }}</mat-label>
          <input matInput formControlName="facilityId" />
        </mat-form-field>

        <mat-form-field
          subscriptSizing="dynamic"
          class="no-display"
          hideRequiredMarker
          *appHasPermission="'appointment.estimate.charge.view'"
        >
          <mat-label>
            {{ 'charges-table.form.unit-charge' | translate }}</mat-label
          >
          <input matInput formControlName="unitCharge" />
        </mat-form-field>

        <mat-form-field
          subscriptSizing="dynamic"
          class="no-display"
          fxFlex="1 1 100px"
          hideRequiredMarker
          *appHasPermission="'appointment.estimate.charge.view'"
        >
          <mat-label>
            {{ 'charges-table.form.total-charge' | translate }}</mat-label
          >
          <input matInput formControlName="totalCharge" />
        </mat-form-field>
      </div>
      <div class="charge-actions" *ngIf="!readOnly">
        @if (currentlyEditingIndex === i) {
        <button
          mat-icon-button
          color="warn"
          (click)="cancelEditEstimateItem(i)"
        >
          <mat-icon>cancel</mat-icon>
        </button>
        } @else {
        <button
          mat-icon-button
          color="primary"
          (click)="editEstimateItem(i)"
          [disabled]="
            currentlyEditingIndex !== null ||
            !chargesFormArray.at(i).get('cptCode').value
          "
        >
          <mat-icon>edit</mat-icon>
        </button>
        } @if (showDiscountControls) {
        <mmx-discount-menu-button
          [discountInputAdded]="chargesFormArray.at(i).contains('cptDiscount')"
          (discountSelected)="onAddChargeDiscountControl($event.type, i)"
          (removeDiscountControl)="onRemoveChargeDiscountControl(i)"
        ></mmx-discount-menu-button>
        }

        <button
          mat-icon-button
          color="warn"
          (click)="removeEstimateItem(i)"
          [disabled]="currentlyEditingIndex !== null"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    }
</div>
<div *ngIf="!estimateService.visitNumbersValid" fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="center center" class="mt-3">
  <mat-icon class="text-danger" color="warn">warning</mat-icon>
  <span *ngIf="invalidInputString && noAppointmentsSelected" class="text-warn"> {{ 'charges-table.form.invalid-input-string-warning' | translate }}</span>
  <span *ngIf="!allVisitNumbersApplied" class="text-warn"> {{ 'charges-table.form.all-applied-warning' | translate }}</span>
  <span *ngIf="chargeMissingVisitNumber" class="text-warn"> {{ 'charges-table.form.visit-number-required-warning' | translate }}</span>

</div>
<div *ngIf="!readOnly" fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="1rem" class="mt-3">
  @if (hbEnabled$ | async) {
  <button
    mat-flat-button
    color="primary"
    [disabled]="
      (chargesFormArray.invalid && chargesFormArray.length > 0) ||
      currentlyEditingIndex !== null
    "
    [matTooltip]="'charges-table.form.add-charge' | translate"
    (click)="addEstimateItem('hb')"
  >
    <mat-icon>add</mat-icon>
    Add HB Charge
  </button>
  } @if (pbEnabled$ | async) { @if (hbEnabled$ | async) {
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>PB Facility</mat-label>
    <mat-select [(ngModel)]="pbFacilityId">
      @for (facility of pbFacilities$ | async; track facility.id) {
      <mat-option [value]="facility.id">{{ facility.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }

  <button
    mat-flat-button
    color="primary"
    [disabled]="
      ((hbEnabled$ | async) && !pbFacilityId) ||
      (chargesFormArray.invalid && chargesFormArray.length > 0) ||
      currentlyEditingIndex !== null
    "
    [matTooltip]="'charges-table.form.add-charge' | translate"
    (click)="addEstimateItem('pb')"
  >
    <mat-icon>add</mat-icon>
    Add PB Charge
  </button>
  }
</div>
